/**
 * @generated SignedSource<<febffeabd949b7f1c72d6051e059f34a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrainSearchPageHeaderFragment$data = {
  readonly contentUsage: {
    readonly content: {
      readonly name: string | null;
      readonly type: ContentType;
    };
    readonly id: string;
    readonly parentApp: {
      readonly customAppTitle: string | null;
      readonly kind: ProductAppKind;
    } | null;
    readonly product: {
      readonly name: string;
      readonly slug: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchSidePanelToggle_ContentUsageFragment" | "ContentUsageUtils_useContentUsagePathContentUsageFragment">;
  } | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonBrainSearchFragment" | "BrainSearchMoreActionsButtonFragment">;
  readonly " $fragmentType": "BrainSearchPageHeaderFragment";
};
export type BrainSearchPageHeaderFragment$key = {
  readonly " $data"?: BrainSearchPageHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchPageHeaderFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchPageHeaderFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsage",
      "kind": "LinkedField",
      "name": "contentUsage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "parentApp",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customAppTitle",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContentUsageUtils_useContentUsagePathContentUsageFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BrainSearchSidePanelToggle_ContentUsageFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchMoreActionsButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkButtonBrainSearchFragment"
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};
})();

(node as any).hash = "fa4932c4484eb70120180e2dbee447ca";

export default node;
